var render, staticRenderFns
import script from "./HiddenFields.vue?vue&type=script&lang=js&"
export * from "./HiddenFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HiddenFields.vue"
export default component.exports